export default __webpack_public_path__ + "images/54f6aeefeeb265f595cf4bce7e1751bb-reviews-info.svg";